import Spacer from "../../components/global/navigation/Spacer";
import useDigiohQuizCompleteMessage from "../../hooks/digioh/useDigiohQuizCompleteMessage";
import useRequireEnabledVariation from "../../hooks/useRequireEnabledVariation";

const digiohHtml = `
  <div class="digioh_universal_smart_tag" style="text-align: center;">
    <div class="box_loading_placeholder" style="position: relative; text-align: center;border-style: none;border-width: 0px;background-color: #fff;height: 750px;width: 100%;">
      <div class="box_loading_placeholder_overlay" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%; background: rgba(255, 255, 255, 0.25);"></div>
      <div style="width: 100%; font-family: Montserrat, sans-serif; font-size: 18px; line-height: 28px; color: #222525; position: relative; top: 50%; transform: translateY(-50%);">
        <img class="box_loading_placeholder_image" src="https://s3.lightboxcdn.com/vendors/e64fdb6a-9235-4648-be35-c296e6aff92e/uploads/75a660a1-4864-43ce-8bd6-28c3cae7f34a/Ritual-Loading-Animation.gif" style="margin: 0 auto; max-height: 100%; max-width: 100%;" alt="Loading...">
        <p><a href='https://www.digioh.com/' target='_blank' style='color: inherit; text-decoration: none;'>Product Recommendation Quiz</a></p>
      </div>
    </div>
  </div>
`;

const Quiz = () => {
  const enabled = useRequireEnabledVariation("enable-quiz", {
    onDisabled: { navigateTo: "/" },
  });

  useDigiohQuizCompleteMessage((event) => {
    // eslint-disable-next-line no-console
    console.log("Quiz completed:", event.data.data);
  });

  if (!enabled) {
    return null;
  }

  return (
    <>
      <Spacer />
      <div dangerouslySetInnerHTML={{ __html: digiohHtml }} />
    </>
  );
};

export default Quiz;
